import { render, staticRenderFns } from "./AEstudianteByDoc.vue?vue&type=template&id=3f37b4a8"
import script from "./AEstudianteByDoc.vue?vue&type=script&lang=js"
export * from "./AEstudianteByDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports